module.exports = __webpack_public_path__ + "static/c4-94e056f547969a60e3dcfcdc89aa38f2.png";